import React from 'react'
import SearchCard from '../card/searchCard.js'
import { auth } from 'components/auth/auth.js'
import Slider from 'react-slick'
import { SEARCH_IMAGE_PARAMS } from 'constants/images/sizesAndQuality.js'
import ProgressImage from '../.././../elements/progressiveImages'
import { CLOUDINARY_API_KEY, CLOUDINARY_NAME } from '../../../../constants/images/cloudinary.js'
import { FakeCardsArray } from 'components/search/skeleton/MainSearchSkeleton.js'
import cloudinary from 'cloudinary-core'
let classNames = require('classnames')
const cl = new cloudinary.Cloudinary({
  cloud_name: CLOUDINARY_NAME,
  api_key: CLOUDINARY_API_KEY,
})

var sliderSettings = {
  dots: false,
  infinite: true,
  speed: 700,
  lazyLoad: "ondemand",
  slidesToShow: 1,
  slidesToScroll: 1,
  nextArrow: null,
  prevArrow: null,
  innerSlider: undefined,
}

const AdvertisementCard = ({ advertisement, searchCardClass}) => {
  if (!advertisement) return null // Return nothing if there's no advertisement
  const { link } = advertisement

  return (
    <div className={`searchCard column ${searchCardClass}`}>
      <a
        href={link || '#'}
        target={link ? '_blank' : '_self'}
        rel="noopener noreferrer"
        onClick={(e) => {
          if (!link) {
            e.preventDefault() // prevent refresh when link is missing
          }
        }}
      >
        <div className="search-cardInfo-images-price mb-3">
          <Slider {...sliderSettings}>
            <ProgressImage
              key={advertisement.image?.cloudinary_public_id}
              overlaySrc={cl.url(`${advertisement.image?.cloudinary_public_id}`)}
              src={cl.url(`${advertisement.image?.cloudinary_public_id}`)}
              className="search-cardInfo-image"
              alt="advertisement-image"
            />
          </Slider>
        </div>
      </a>
    </div>
  )
}

class SearchResults extends React.Component {
  constructor(props) {
    super(props)
    this.bottomObserver = null
    this.bottomObserverRef = React.createRef()
  }

  componentDidMount() {
    // Initialize the Intersection Observer when component mounts
    this.bottomObserver = new IntersectionObserver(this.handleObserver, {
      root: null,
      rootMargin: '0px',
      threshold: 0.01,
    })

    // Observe the reference to the bottom element
    if (this.bottomObserverRef.current) {
      this.bottomObserver.observe(this.bottomObserverRef.current)
    }
  }

  componentWillUnmount() {
    // Disconnect the Intersection Observer when component unmounts
    if (this.bottomObserver) {
      this.bottomObserver.disconnect()
    }
  }

  handleObserver = (entries) => {
    // If the bottom element is intersecting, call loadMore
    const { page, total_pages } = this.props.searchMeta || {}
    if (entries[0].isIntersecting && page <  total_pages) {
      this.loadMore()
    }
  }

  loadMore = () => {
    const { page } = this.props.searchMeta || { page: 1 }
    this.props.loadMore(page + 1)
  }

  fourColumns = () => {
    let fourCols = false

    const { isMobile, mapVisible, overRideLayout } = this.props

    if (!isMobile && mapVisible && !overRideLayout) {
      fourCols = true
    }

    if (!isMobile && overRideLayout === 3) {
      fourCols = true
    }

    return fourCols
  }

  isFocused = (bikeID) => {
    if (bikeID === this.props.focusedResult) {
      return true
    } else {
      return false
    }
  }

  // Function to calculate ad indexes
  calculateIndexes = (indexes, total_results) => {
    let currentIndex = indexes[0] // Start from initial spot
    let increment = 4
    while (currentIndex < total_results) {
      currentIndex += increment
      indexes.push(currentIndex)
    }
  }

  render() {
    const {
      isMobile,
      mapVisible,
      searchResults,
      startDate,
      endDate,
      overRideLayout,
      isSearchPage,
      allAdvertisements,
      searchLoading,
      searchMeta,
      currentTotalResults,
      userCreditsCents,
      userFreeDays,
      ridesUntilFreeDay,
      userIsRpmComotoMember,
      isAuth
    } = this.props

    const userUnusedCredits = userCreditsCents > 0 ? userCreditsCents / 100 : 0

    const {
      non_logged_in_user,
      unused_credits_and_free_days,
      unused_credits_and_free_day,
      unused_free_days,
      unused_free_day,
      unused_credits,
      rpm_comoto_member,
      one_ride_away,
      two_rides_away,
    } = JSON.parse(allAdvertisements || "{}")

    const { total_results } = searchMeta || {}

    const isAuthenticated = auth.isAuthenticated()
    const isTripTaken = Number(auth.userRideTakenCount()) > 0 ? true : false

    let advertisementFirst = null
    let firstAdIndexes = [1]

    const hasUnusedFreeDay = userFreeDays > 0
    const isRpmComoto = userIsRpmComotoMember

    if (!isAuthenticated) {
      advertisementFirst = non_logged_in_user
    } else {
      if (userUnusedCredits > 0 && hasUnusedFreeDay) {
        advertisementFirst = userFreeDays > 1 ? unused_credits_and_free_days : unused_credits_and_free_day
      } else if (hasUnusedFreeDay) {
        advertisementFirst = userFreeDays > 1 ? unused_free_days : unused_free_day
      } else if (userUnusedCredits > 0) {
        advertisementFirst = unused_credits
      } else if (isRpmComoto) {
        advertisementFirst = rpm_comoto_member
      } else if (ridesUntilFreeDay === 1) {
        advertisementFirst = one_ride_away
      } else if (ridesUntilFreeDay === 2) {
        advertisementFirst = two_rides_away
      }
    }

    if (firstAdIndexes.length > 0) this.calculateIndexes(firstAdIndexes, total_results)

    let searchCardClass = classNames('', null, {
      'is-6': !isMobile && mapVisible && !overRideLayout,
      'is-3': !isMobile && !mapVisible && !overRideLayout,
      'is-12': isMobile,
      [`is-${overRideLayout}`]: overRideLayout,
    })

    return (
      <React.Fragment>
        {searchResults && currentTotalResults > 0 && (
          <div className="columns is-multiline">
            {searchResults.map((result, index) => {
              const shouldShowAd = firstAdIndexes.includes(index) &&
                ((isAuthenticated && advertisementFirst) || (!isAuthenticated && advertisementFirst))

              return (
                <React.Fragment key={result.bike_id}>
                  {shouldShowAd && (
                    <AdvertisementCard
                      advertisement={advertisementFirst}
                      searchCardClass={searchCardClass}
                    />
                  )}
                  <SearchCard
                    cardInfo={result}
                    className={searchCardClass}
                    focusedResult={this.props.focusedResult}
                    startDate={startDate}
                    endDate={endDate}
                    showDistance={true}
                    onHover={this.props.onResultHover}
                    titleSize={this.props.cardTitleSize}
                    isSearchPage={isSearchPage}
                    isAuthenticated={isAuthenticated}
                    isTripTaken={isTripTaken}
                    currentIndex={index}
                  />
                </React.Fragment>
              )
            })}
            {searchLoading && currentTotalResults > 0 && (
              <FakeCardsArray searchCardClass={'searchCard column ' + searchCardClass} />
            )}
            <div ref={this.bottomObserverRef}></div>
          </div>
        )}
      </React.Fragment>
    )
  }
}

export default SearchResults

SearchResults.defaultProps = {
  searchResults: [],
  startDate: null,
  endDate: null,
  overRideLayout: false,
  onResultHover: function () { },
  cardTitleSize: 'is-size-4',
}
